import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Timeline() {
  return (
    <section className="timeline-section section-padding">
      <Container>
        <Row>
          <Col>
            <div className="foundation-whyus-content">
              <h1 className="mb-5 section-title  text-center">
                Timeline of Co-Creation
              </h1>

              <Row>
                {/* <Col md="4">
                  <div className="product-item text-center">
                    <StaticImage
                      className="img-fluid mb-5"
                      src="../../images/pin-founded.png"
                      alt="founded"
                    />
                  </div>
                  <h1 className="mb-3 font-weight-bold text-center">2017</h1>
                  <p className="mb-3 font-weight-bold text-center">
                    Fluo is founded
                  </p>
                </Col>
                <Col md="4">
                  <div className="product-item  text-center">
                    <StaticImage
                      className="img-fluid mb-5"
                      src="../../images/pin-copyright.png"
                      alt="copyright"
                    />
                  </div>
                  <h1 className="mb-3 font-weight-bold text-center">2017</h1>
                  <p className="mb-3 font-weight-bold text-center">
                    "Feel Alive" Trademark Est
                  </p>
                </Col>
                <Col md="4">
                  <div className="product-item  text-center">
                    <StaticImage
                      className="img-fluid mb-5"
                      src="../../images/pin-logo.png"
                      alt="logo"
                    />
                  </div>
                  <h1 className="mb-3 font-weight-bold text-center">2021</h1>
                  <p className="mb-3 font-weight-bold text-center">
                    FLUO Debuts in U.S.A.
                  </p>
                </Col> */}
                <Col md="12 mx-auto">
                  <div className="product-item text-center">
                    <StaticImage
                      className="img-fluid mb-5"
                      src="../../images/map-timeline-final.png"
                      alt="founded"
                    />
                  </div>
                </Col>
              </Row>
              <h1 className=" mb-3 font-weight-bold mt-5">What lies beyond?</h1>
              <p className="">
                FLUO is just beginning, but our vision is revolutionary. We
                intend to change how business is done and rally all conscious
                consumers to the forefront of our epic movement to be the
                co-creators of our future. It is our time! We get to decide how
                our money is spent and how our voices are heard. We will be the
                ones that bend history in the right direction!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
